module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/dash-board/dashboard-quickresend/dashboard-quickresend.component.css
// module id = ./src/app/dash-board/dashboard-quickresend/dashboard-quickresend.component.css
// module chunks = main